<template>
  <div>
    <NavBar />
    <div
      class="max-w-[1600px] mx-auto flex flex-col lg:flex-row lg:gap-8 px-4 sm:px-6 lg:px-10 pt-20 sm:pt-24 pb-12"
    >
      <MenuLeft />
      <main class="w-full lg:flex-1 min-w-0">
        <slot></slot>
      </main>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TemplateDefault',
}
</script>
